import { render, staticRenderFns } from "./bgCotainer.vue?vue&type=template&id=5149d56e&scoped=true"
import script from "./bgCotainer.vue?vue&type=script&lang=js"
export * from "./bgCotainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149d56e",
  null
  
)

export default component.exports